<script>
	import { getContext, onMount } from 'svelte'
	import DraggableComponent from '@Components/DraggableComponent.svelte'
	import { on } from 'svelte/events'
	let { visible = false, hasActiveFilter = $bindable(false) } = $props()
	const { getEditorCanvas, isDev, getController } = getContext('editor')
	const controller = getController()
	const subscription = controller.getSubscription()
	const subscriptionFilter = ['premium']
	const basicDisabled = !subscriptionFilter.includes('premium')
	let canvas = getEditorCanvas()
	let filters = $state([
		{
			title: 'Frames',
			id: 'holeFrames',
			key: 'objectType',
			values: ['frame'],
			disabled: false,
			properties: ["holeId"]
		},
		{
			title: 'Overview frames',
			id: 'overviewFrames',
			key: 'objectType',
			values: ['frame'],
			disabled: basicDisabled,
			properties: ["courseId"]
		},
		{
			title: 'Focus',
			id: 'focus',
			key: 'elementName',
			disabled: false,
			values: ['focus', 'greenfocus']
		},
		{
			title: 'Icons',
			id: 'icons',
			key: 'elementName',
			disabled: basicDisabled,
			values: ['icon', 'holeicon']
		},
		{
			title: 'Trees & bushes',
			id: 'trees',
			key: 'elementName',
			disabled: false,
			values: ['bush', 'tree']
		},
		{
			title: 'Penaly Area',
			id: 'penaltyarea',
			key: 'elementName',
			disabled: basicDisabled,
			values: ['penaltyarea']
		},
		{
			title: 'Bunkers',
			id: 'bunkers',
			key: 'elementName',
			disabled: false,
			values: ['bunker', 'grassbunker']
		},
		{
			title: 'Fairway',
			id: 'fairway',
			key: 'elementName',
			disabled: false,
			values: ['fairway']
		},
		{
			title: 'Rough',
			id: 'rough',
			key: 'elementName',
			disabled: false,
			values: ['rough']
		},
		{
			title: 'Green',
			id: 'green',
			key: 'elementName',
			disabled: false,
			values: ['green', 'puttinggreen']
		},
		{
			title: 'Semigreen',
			id: 'semigreen',
			key: 'elementName',
			disabled: basicDisabled,
			values: ['semigreen']
		},
		{
			title: 'Tee',
			id: 'tee',
			key: 'elementName',
			disabled: false,
			values: ['tee']
		},
		{
			title: 'Range Tee',
			id: 'rangetee',
			key: 'elementName',
			disabled: basicDisabled,
			values: ['rangetee']
		},
		{
			title: 'Forests',
			id: 'forests',
			key: 'elementName',
			disabled: false,
			values: ['forest']
		},
		{
			title: 'Mountain',
			id: 'mountain',
			key: 'elementName',
			disabled: false,
			values: ['mountain']
		},
		{
			title: 'Stonewall',
			id: 'stonewall',
			key: 'elementName',
			disabled: basicDisabled,
			values: ['stonewall']
		},
		{
			title: 'Road',
			id: 'road',
			key: 'elementName',
			disabled: false,
			values: ['road', 'asphalt']
		},
		{
			title: 'Path',
			id: 'path',
			key: 'elementName',
			disabled: false,
			values: ['path', 'gravel']
		},
		{
			title: 'Wastearea',
			id: 'wastearea',
			key: 'elementName',
			disabled: false,
			values: ['wastearea']
		},
		{
			title: 'Buidlings',
			id: 'buidlings',
			key: 'elementName',
			disabled: basicDisabled,
			values: ['flatroofbuilding', 'slantedroofbuilding']
		},
		{
			title: 'Water',
			id: 'water',
			key: 'elementName',
			disabled: false,
			values: ['water', 'stream']
		},
		{
			title: 'Playline',
			id: 'playline',
			key: 'objectType',
			disabled: basicDisabled,
			value: 'playline'
		},
		{
			title: 'Bridges',
			id: 'bridges',
			key: 'elementName',
			disabled: basicDisabled,
			value: ['bridge']
		},
		{
			title: 'Thicket',
			id: 'thicket',
			key: 'elementName',
			disabled: basicDisabled,
			value: ['thicket']
		},
		{
			title: 'Tee points',
			id: 'teepoints',
			key: 'elementName',
			disabled: false,
			values: ['teeyellowblack', 'teegreenwhite', 'teeorange', 'teered', 'teeblue', 'teeyellow', 'teewhite', 'teeblack']
		},
		{
			title: 'Green points',
			id: 'greenpoints',
			key: 'elementName',
			disabled: false,
			values: ['greencenter','greenback','greenfront']
		}
	].filter((f) => !f.disabled))
	let filterValues = $state({
		trees: true,
		holeFrames: true,
		overviewFrames: true,
		icons: true,
		bunkers: true,
		mountain: true,
		stonewall: true,
		penaltyarea: true,
		road: true,
		path: true,
		wastearea: true,
		fairway: true,
		rough: true,
		green: true,
		buidlings: true,
		forests: true,
		water: true,
		focus: true,
		playline: true,
		tee: true,
		rangetee: true,
		semigreen: true,
		teepoints: true,
		greenpoints: true,
		thicket: true,
		bridges: true
	})
	function updateCanvas() {
		let result = []
		for (let filter in filterValues) {
			if (filterValues[filter] === false) {
				let filterObj = filters.find((f) => f.id === filter)
				if (filterObj) {
					result.push(filterObj)
				}
			}
		}
		if (isDev) {
			localStorage.setItem('filterValues', JSON.stringify(filterValues))
		}
		hasActiveFilter = result.length > 0
		canvas.filterElements(result)
	}
	function reset() {
		for (let filter in filterValues) {
			filterValues[filter] = true
		}
		hasActiveFilter = false
		updateCanvas()
	}
	function filterAll() {
		let result = []
		for (let filter in filterValues) {
			filterValues[filter] = false
		}
		hasActiveFilter = true
		updateCanvas()
	}
	onMount(() => {
		if (isDev) {
			let storedFilterValues = localStorage.getItem('filterValues')
			if (storedFilterValues) {
				filterValues = JSON.parse(storedFilterValues)
				updateCanvas()
			}
		}
	})
</script>

<DraggableComponent initialY="60" yAlignment="bottom" xAlignment="right" closable={true} bind:visible>
	<div class="flex text-sm flex-col text-left pt-0">
		<div class="text-left w-full font-bold p-2 pt-0 select-none">Visible elements</div>
		<div class="flex text-sm flex-col gap-2 bg-neutral-200 dark:bg-bigsteel-900/20 p-2 list">
			{#each filters as filter}
				<div class="flex flex-row gap-2">
					<input
						name={filter.name}
						onchange={(e) => {
							filterValues[filter.id] = e.target.checked
							updateCanvas()
						}}
						type="checkbox"
						bind:checked={filterValues[filter.id]}
					/>
					<label tooltip={filter.tooltip} for={filter.name}>{filter.title}</label>
				</div>
			{/each}
		</div>
		<div class="flex gap-2 p-2">
			<button
				name="edit"
				tooltip="Press to filter all objects listed above"
				class="btn btn-sm flex-1"
				class:btn-solid-blue={!isDarkMode}
				class:btn-solid-white={isDarkMode}
				onclick={() => {
					filterAll()
				}}>None</button
			>
			<button
				name="edit"
				tooltip="Remove all filters"
				class="btn btn-sm flex-1"
				class:btn-solid-blue={!isDarkMode}
				class:btn-solid-white={isDarkMode}
				onclick={() => {
					reset()
				}}>All</button
			>
		</div>
	</div>
</DraggableComponent>

<style lang="postcss">
	.list {
		width: 160px;
		min-height: 200px;
		max-height: calc(100vh - 640px);
		overflow-y: auto;
	}
</style>
